"use strict";

/**
 * @classdesc
 * Admin-Modul
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Aufrufoptionen
 * @param {string} options.alias
 * @param {string} options.target
 * @param {gc.gis.map.GCMapView} [options.map=gc.gis.iface.map]
 * @param {string} [options.label='Ansichten']
 * @param {string} options.requests.adminGetConfigUrl
 * @param {string} options.requests.adminSetConfigUrl
 */
gc.gis.module.GCAdmin = function (options) {
    gc.gis.module.GCAbstractModule.call(this, options);

    this.options = options;
    this.map = options.map || gc.gis.iface.map;
    this.label = options.label || 'Administration';
    this.adminGetConfigUrl = options.requests.adminGetConfigUrl;
    this.adminSetConfigUrl = options.requests.adminSetConfigUrl;

    this._render();

    this.launcher = {
        label: this.label,
        //icon: 'glyphicon glyphicon-wrench',
        //icon: 'glyphicon glyphicon-king',
        icon: 'glyphicon glyphicon-asterisk',
        content: new gc.gis.ui.GCSidebarContent({
            label: this.label,
            'parent': null,
            element: this.getElement()
        })
    };
    gc.gis.iface.ui.sidebar.addLauncher(this.launcher);
};
gc.gis.module.GCAdmin.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);

/**
 *
 */
gc.gis.module.GCAdmin.prototype.getElement = function () {
    return this._element_panel.getElement();
};

/**
 *
 */
gc.gis.module.GCAdmin.prototype._render = function () {
    this._element_panel = new gc.gis.module.GCAdmin.Panel({
        module: this
    });

    return this._element;
};
